import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import authService from '../../../services/auth.service';
import { USER_QUERY_KEY } from '../../../constants/query';
import { logout as resetTokens } from '../../../utils/helpers';
import { CUSTOMER_QUERY_KEY } from '../../../constants/query';

const useLogutUser = () => {
  const queryClient = useQueryClient();

  const logout = useCallback(() => {
    authService.logout();
    queryClient.cancelQueries({
      queryKey: USER_QUERY_KEY,
    });
    queryClient.resetQueries({ queryKey: USER_QUERY_KEY, exact: true });
    queryClient.resetQueries({ queryKey: CUSTOMER_QUERY_KEY, exact: true });
    resetTokens();
    queryClient.clear();
  }, [queryClient]);

  return {
    logout,
  };
};

export default useLogutUser;
